import React from "react";
import { Col, Row } from "reactstrap";
import banner from "../../assets/images/banner.webp"

export const Banner = () => {
  return (
    <>
      
      <Row className="container-banner">
        <Col className="d-flex flex-column align-items-center justify-content-center w-100">
          <h1 className="banner-title"> 
            ¡Bienvenido al sistema de reclutamiento de Konecta Argentina!
          </h1>
          <img src={banner} width="70%" className="my-4" alt="Banner de reclutamiento de Konecta con un hombre sonriendo y mirando a través de una lupa. Contiene un texto que dice: Te invitamos a conocer todas nuestras oportunidades laborales activas. Postulate a la de tu interés completando el formulario con tus datos." />
          <div className="banner-sub-title">
            <p>
              Si tu perfil profesional cumple con nuestros requerimientos,
              <br />
              nos pondremos en contacto con vos.
            </p>
            <p>
              ¡Gracias por elegirnos!
            </p>
          </div>
        </Col>
      </Row>
    </>
  );
};


